import React, { useState } from 'react';
import './CombatTutorial.css';

/**
 * Step-through tutorial tips for a player's first combat.
 * Shows during the tutorial ambush or any fight at level 1 if not yet seen.
 */

const STEPS = [
  {
    title: 'Your Cards',
    text: 'These are your combat cards. Each card has a different effect — attacks deal damage, spells cost MP, and items can heal you.',
    icon: '🃏',
    highlight: 'cards',
  },
  {
    title: 'Action Points (AP)',
    text: 'You have 3 AP per turn. Each card costs AP to play (shown on the card). Plan your turn wisely!',
    icon: '💎',
    highlight: 'ap',
  },
  {
    title: 'End Your Turn',
    text: 'When you\'ve spent your AP (or want to save cards), click End Turn. The monster will then take its turn.',
    icon: '⏭️',
    highlight: 'endturn',
  },
  {
    title: 'Win the Fight!',
    text: 'Reduce the monster\'s HP to 0 to win! You\'ll earn gold and experience. Good luck, adventurer!',
    icon: '⚔️',
    highlight: null,
  },
  {
    title: 'Build Your Deck',
    text: 'Out of combat, open the Deck panel (🃏 in the top bar) to swap cards in and out of your loadout. Race and class give you starting cards — quests, crafting, and shops grant more.',
    icon: '🃏',
    highlight: null,
  },
  {
    title: 'Choices Matter',
    text: 'Quest dialogue can shift your alignment and even lock out entire chains. When a choice carries weight, the game will tell you. Pick the path you want to play.',
    icon: '⚖️',
    highlight: null,
  },
];

const CombatTutorial = ({ onComplete, characterId }) => {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;
  const storageKey = `loria_combat_tutorial_seen_${characterId || 'default'}`;

  const handleNext = () => {
    if (isLast) {
      localStorage.setItem(storageKey, '1');
      onComplete();
    } else {
      setStep(s => s + 1);
    }
  };

  return (
    <div className="ct-overlay">
      <div className="ct-tooltip" data-highlight={current.highlight || 'none'}>
        <div className="ct-step-counter">{step + 1} / {STEPS.length}</div>
        <div className="ct-icon">{current.icon}</div>
        <h3 className="ct-title">{current.title}</h3>
        <p className="ct-text">{current.text}</p>
        <div className="ct-buttons">
          {step > 0 && (
            <button className="ct-btn ct-btn-back" onClick={() => setStep(s => s - 1)}>← Back</button>
          )}
          <button className="ct-btn ct-btn-next" onClick={handleNext}>
            {isLast ? 'Got it! ⚔️' : 'Next →'}
          </button>
        </div>
        <button className="ct-skip" onClick={() => { localStorage.setItem(storageKey, '1'); onComplete(); }}>
          Skip tips
        </button>
      </div>
    </div>
  );
};

export default CombatTutorial;
